import {Reducer} from 'redux';
import {Days, DaySchedule, listOfDay} from '../entities';
import {IDistibuteSchedule, IDuplicateSchedule, IEditSchedule, TSchedule} from '../actions';

export interface IScheduleState {
  id?: string;
  [Days.MONDAY]?: DaySchedule;
  [Days.TUESDAY]?: DaySchedule;
  [Days.WEDNESDAY]?: DaySchedule;
  [Days.THURSDAY]?: DaySchedule;
  [Days.FRIDAY]?: DaySchedule;
  [Days.SATURDAY]?: DaySchedule;
  [Days.SUNDAY]?: DaySchedule;
  scheduleUpdateLoading: boolean;
}

export const defaultScheduleState = {
  scheduleUpdateLoading: false
}

const daySchedulesListToScheduleDayMap = (payload: any): any =>
  payload.schedule.reduce((acc, place, index) => ({
    ...acc,
    [place.day || listOfDay[index]]: place.daySchedule
  }), {id: payload.id} as IScheduleState)
;

export const scheduleReducer: Reducer<IScheduleState> = (
  state: IScheduleState = defaultScheduleState,
  action: IDistibuteSchedule | IDuplicateSchedule | IEditSchedule
): IScheduleState => {
  switch (action.type) {
    case TSchedule.DISTRIBUTE_SCHEDULE:
      return { ...state, ...daySchedulesListToScheduleDayMap(action.payload), scheduleUpdateLoading: false };
    case TSchedule.DUPLICATE_SCHEDULE:
      return { ...state, scheduleUpdateLoading: true };
    case TSchedule.EDIT_SCHEDULE:
      return {...state, scheduleUpdateLoading: true};

    default:
      return state;
  }
};
